import { Link } from "react-router-dom";
import { Wrench, Car, ArrowRight } from "lucide-react";

export default function AutoCareCta({ variant = "card", context = "" }) {
  if (variant === "inline") {
    return (
      <p className="text-sm text-slate-400" data-testid="autocare-cta-inline">Need repairs first? <Link to="/auto-care?dept=body_shop" className="text-cyan-300 hover:text-white underline underline-offset-4">Body shop</Link> · <Link to="/auto-care?dept=mechanic" className="text-cyan-300 hover:text-white underline underline-offset-4">Mechanic</Link> — Velocity Auto Care</p>
    );
  }
  return (
    <section className="rounded-3xl border border-slate-800 bg-[#131722] p-6 grid sm:grid-cols-[1fr_auto] gap-4 items-center" data-testid="autocare-cta">
      <div>
        <p className="font-mono text-[11px] tracking-[0.2em] text-cyan-400 mb-1">VELOCITY AUTO CARE</p>
        <h2 className="text-base md:text-lg font-semibold text-white">Keep your car road-ready{context ? ` ${context}` : ""}.</h2>
        <p className="text-sm text-slate-400 mt-1">Request a body-shop or mechanic assessment. The team confirms your visit — no login needed.</p>
      </div>
      <div className="flex gap-2 flex-wrap">
        <Link to="/auto-care?dept=body_shop" className="h-10 px-4 rounded-full border border-slate-700 text-sm text-slate-200 hover:border-cyan-400 inline-flex items-center gap-2" data-testid="autocare-cta-body"><Car className="w-4 h-4" />Body shop</Link>
        <Link to="/auto-care?dept=mechanic" className="h-10 px-4 rounded-full bg-cyan-400 text-slate-950 text-sm font-semibold inline-flex items-center gap-2" data-testid="autocare-cta-mechanic"><Wrench className="w-4 h-4" />Mechanic <ArrowRight className="w-4 h-4" /></Link>
      </div>
    </section>
  );
}
